import React from 'react';

const FlavorIcon = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 104 105"
  >
    <g
      fill="none"
      fillRule="evenodd"
      stroke="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    >
      <g stroke={props.color} strokeWidth="3.5" transform="translate(-493 -704)">
        <g transform="translate(495 706)">
          <path d="M84.758 13.381c-6.873 2.502-14.601-1.396-14.601-1.396S73.572 4.03 80.445 1.529c6.873-2.501 14.601 1.397 14.601 1.397s-3.415 7.954-10.288 10.455h0z" />
          <path d="M55.445 13.381c6.873 2.502 14.601-1.396 14.601-1.396S66.631 4.03 59.758 1.529C52.885-.972 45.157 2.926 45.157 2.926s3.415 7.954 10.288 10.455h0z" />
          <circle cx="25" cy="66" r="25" />
          <path d="M8 66c0 2.173.408 4.25 1.15 6.16m6.456-20.331a17.062 17.062 0 00-6.315 7.66" />
          <circle cx="75" cy="76" r="25" />
          <path d="M70 11s-1.512 12.77-11.71 25.976c-10.198 13.205-22.416 17.02-22.416 17.02" />
          <path d="M70.738 11S80.74 24.565 80.74 39.356c0 14.791-3.813 19.7-3.813 19.7" />
          <path d="M29.025 52.213a7 7 0 004.95 8.574h0" />
          <path d="M70 61.394a7 7 0 008.972 4.184h0" />
        </g>
      </g>
    </g>
  </svg>
);

export default FlavorIcon;



// WEBPACK FOOTER //
// ./src/icons/FlavorIcon.jsx